<template>
  <div class="item" :class="{ disabled: type !== 1 }">
    <div class="model-name-now">
      <div class="name">{{item.name}}</div>
      <div class="now">{{ type === 1 ? '当前使用' : '已订购' }}</div>
    </div>
    <div class="text-item">
      <div class="label">截止至</div>
      <div class="info">{{item.end_time}}</div>
    </div>
    <div class="text-item">
      <div class="label">可用</div>
      <div class="info">{{item.month}}个月</div>
    </div>
    <div class="text-item">
      <div class="label">费用</div>
      <div class="info wechatNumber">{{item.price}}元</div>
    </div>
    <div class="text-item" v-if="item.deposit * 1 && type === 1">
      <div class="label">押金</div>
      <div class="info wechatNumber">{{item.deposit}}元</div>
      <img :src="IconFeedback" class="feed-icon" @click.stop="ShowTips" />
    </div>
    <div class="btn" v-if="status * 1 === 3  && type === 1">
      <Btn title="押金退还" size="md" @click="RefundMoney" />
    </div>
  </div>
</template>

<script>
  import { SetImage } from '@/utils/Image'
  import { mapState } from 'vuex'
  export default {
    methods: {
      ShowTips () {
        this.$ShowConfirm(
          this.desc,
          {
            title: '押金说明',
            showCancel: false,
            messageAlign: 'left',
            confirmText: '我知道了'
          }
        )
      },
      RefundMoney () {
        this.$ShowConfirm('您已满足押金退还条件，是否申请退还押金？').then(() => {
          this.$Post('Common.CupReturnDeposit', {
            cup_id: this.$route.query.id
          }).then(res => {
            this.$ShowToast(res.msg, { icon: 'success' }).then(() => {
              this.$emit('Refresh')
            })
          })
        })
      }
    },
    computed: {
      ...mapState('Common', ['deposit_explain']),
      ...SetImage(['IconFeedback'])
    },
    props: {
      type: {
        type: null,
        default: 1
      },
      desc: null,
      status: null,
      item: {
        type: Object,
        default: () => ({})
      }
    }
  }
</script>

<style lang="less" scoped>
  .item {
    .br(.1rem);
    .bg(#fff);
    .mb(.24rem);
    .p(.26rem .3rem .18rem);
    position: relative;
    &.disabled {
      .model-name-now {
        .c(#c4c4c4);
        .now {
          .bg(#ecfaff);
          .c(#b8ebff);
        }
      }
      .text-item {
        .label,
        .info {
          .c(#c4c4c4);
        }
      }
    }
    .model-name-now {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .mb(.25rem);
      .c(#333);
      .name {
        .fz(.32rem);
        font-weight: bold;
      }
      .now {
        .w(1.18rem);
        .h(.4rem);
        .br(.2rem);
        .flex-cc();
        .bg(#dbf5ff);
        .c(#00b0f4);
        .fz(.22rem);
      }
    }
    .text-item {
      .h(.3rem);
      .fz(.26rem);
      display: flex;
      align-items: center;
      & + .text-item {
        .mt(.15rem);
      }
      .label {
        .c(#999999);
        .w(1.05rem);
      }
      .info {
        .c(#333);
      }
      .feed-icon {
        .w(.3rem);
        .h(.3rem);
        .ml(.09rem);
      }
    }
    .btn {
      .w(1.6rem);
      position: absolute;
      bottom: .18rem;
      right: .3rem;
    }
  }
</style>
